(() => {
  const launcher = document.getElementById('ASVipLauncher');
  const dialog = document.getElementById('ASVipDialog');
  if (!launcher || !dialog) return;
  const trigger = launcher.querySelector('.as-vip-trigger');
  const form = dialog.querySelector('form');
  const backdrop = document.getElementById('ASVipBackdrop');
  const progress = dialog.querySelector('.as-vip-progress');
  let submissionTimer;
  const captchaVisible = () => [...document.querySelectorAll('iframe[src*="hcaptcha"][src*="frame=challenge"]')].some(frame => {
    const rect = frame.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth && rect.bottom > 0 && rect.top < innerHeight && getComputedStyle(frame).visibility !== 'hidden';
  });
  let previousOverflow;
  const read = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  const subscribedKey = 'as-vip-subscribed';
  const hasSubscribed = () => {
    try { return localStorage.getItem(subscribedKey) === '1' || read(subscribedKey) === '1'; }
    catch (_) { return read(subscribedKey) === '1'; }
  };
  const hideSubscribedOffer = () => {
    launcher.hidden = true;
    write(subscribedKey, '1');
    try { localStorage.setItem(subscribedKey, '1'); } catch (_) {}
  };
  const restoreVisibility = () => { launcher.hidden = hasSubscribed() || read('as-vip-hidden') === '1'; };
  restoreVisibility();
  window.addEventListener('pageshow', restoreVisibility);
  window.addEventListener('storage', event => {
    if (event.key === subscribedKey) restoreVisibility();
  });
  const open = () => {
    if (dialog.open) return;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // A top-layer showModal() makes Shopify's body-level CAPTCHA inert/hidden.
    // Use a fixed dialog + backdrop so the security challenge remains interactive.
    if (backdrop) backdrop.hidden = false;
    dialog.show();
    // Focus the close button without opening the mobile keyboard immediately.
    dialog.querySelector('.as-vip-close').focus({preventScroll: true});
  };
  const close = () => dialog.close();
  trigger.addEventListener('click', open);
  launcher.querySelector('.as-vip-dismiss').addEventListener('click', () => {
    launcher.hidden = true;
    write('as-vip-hidden', '1');
  });
  backdrop?.addEventListener('click', close);
  dialog.querySelector('.as-vip-close').addEventListener('click', close);
  dialog.querySelector('.as-vip-no').addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) close(); });
  document.addEventListener('keydown', event => {
    if (!dialog.open || captchaVisible()) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const items = [...dialog.querySelectorAll('button, input:not([type="hidden"]), a[href], [tabindex="0"]')].filter(e => !e.disabled && e.getClientRects().length && getComputedStyle(e).display !== 'none');
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  });
  dialog.addEventListener('close', () => {
    if (backdrop) backdrop.hidden = true;
    clearTimeout(submissionTimer);
    if (dialog.querySelector('[data-vip-success]')) hideSubscribedOffer();
    document.body.style.overflow = previousOverflow || '';
    if (!launcher.hidden) trigger.focus({preventScroll: true});
  });
  form.addEventListener('submit', () => write('as-vip-submitted', '1'));
  form.querySelector('.as-vip-continue')?.addEventListener('click', () => {
    if (!form.checkValidity()) return;
    write('as-vip-submitted', '1');
    if (progress) {
      progress.hidden = false;
      progress.textContent = 'Please wait. Complete the security check if prompted.';
      clearTimeout(submissionTimer);
      submissionTimer = setTimeout(() => {
        progress.textContent = 'Still waiting for the security check. Please complete it, then try Continue again.';
      }, 15000);
    }
  });
  if (!hasSubscribed() && read('as-vip-submitted') === '1' && (dialog.querySelector('[data-vip-success]') || dialog.querySelector('[data-vip-error]'))) {
    write('as-vip-submitted', '0');
    open();
  }
})();
